import _ from 'lodash';

import analytics from './analytics.js';
import game from './game.js';

export default _.defaultsDeep({},
  analytics,
  game,
);